module.exports = __webpack_public_path__ + "media/retail.ad577661.png";